import { useCallback } from 'react';

import { useSetState } from './use-set-state.js';
import { PAD_ANGLE } from '../../constants.js';
import type { InternalSliceData } from '../../types/internal/pie-chart.js';
import { groupSlicesThinnerThanPadAngle } from '../../utils/group-slices-thinner-than-pad-angle.js';

export const useSetVisibleSlicesState = () => {
  const setState = useSetState();

  const setVisibleSlicesState = useCallback(
    (slices: InternalSliceData[]) => {
      const filteredSlices = groupSlicesThinnerThanPadAngle(slices, PAD_ANGLE);
      setState((prev) => {
        return {
          ...prev,
          visibleSlices: filteredSlices,
        };
      });
    },
    [setState],
  );

  return setVisibleSlicesState;
};
